import React, { useState } from 'react';
import ProductTopSection from '../../../components/Sangjo-Ujieon/ProductTopSection';
import ProductSubHeading from '../../../components/Sangjo-Ujieon/ProductSubHeading';
import openingMovingIcon1 from '../../../assets/img/product-info/open1.png';
import openingMovingIcon2 from '../../../assets/img/product-info/open2.png';
import openingMovingIcon3 from '../../../assets/img/product-info/open3.png';
import openingMovingIcon4 from '../../../assets/img/product-info/open4.png';
import openingMovingIcon5 from '../../../assets/img/product-info/open5.png';

const OpeningMovingMobile = () => {

  return (
    <div className="announcement-list-page product-info-page">
      <ProductTopSection />

      {/* Main Content */}
      <main className="main-content">
        <ProductSubHeading heading="개장/이장" />

        {/* Main Content Section */}
        <div className="opening-moving-mobile-section">
          <h3 className="opening-moving-section-title">개장/이장 절차</h3>

          {/* Content Sections - Opening Moving specific content */}
          <div className="opening-moving-mobile-content-sections">
            {/* Timeline Section */}
            <div className="opening-moving-mobile-timeline-section">
              <div className="opening-moving-mobile-timeline">
                <div className="opening-moving-mobile-timeline-step">
                  <div className="opening-moving-mobile-timeline-icon">
                    <div className="opening-moving-mobile-icon-badge">
                      <img src={openingMovingIcon1} className="opening-moving-mobile-icon" alt="이장지 결정 아이콘" />
                    </div>
                    <div className="opening-moving-mobile-timeline-text">이장지 결정</div>
                  </div>

                  <div className="opening-moving-mobile-timeline-number">1</div>
                </div>

                <div className="opening-moving-mobile-timeline-connector"></div>
                <div className="opening-moving-mobile-timeline-step">
                  <div className="opening-moving-mobile-timeline-icon">
                    <div className="opening-moving-mobile-icon-badge">
                      <img src={openingMovingIcon3} className="opening-moving-mobile-icon" alt="개장 신고 아이콘" />
                    </div>
                    <div className="opening-moving-mobile-timeline-text">개장 신고</div>
                  </div>
                  <div className="opening-moving-mobile-timeline-number">2</div>
                </div>

                <div className="opening-moving-mobile-timeline-connector"></div>

                <div className="opening-moving-mobile-timeline-step">
                  <div className="opening-moving-mobile-timeline-icon">
                    <div className="opening-moving-mobile-icon-badge">
                      <img src={openingMovingIcon2} className="opening-moving-mobile-icon" alt="파묘 아이콘" />
                    </div>
                    <div className="opening-moving-mobile-timeline-text">파묘</div>
                  </div>
                  <div className="opening-moving-mobile-timeline-number">3</div>
                </div>

                <div className="opening-moving-mobile-timeline-connector"></div>

                <div className="opening-moving-mobile-timeline-step">
                  <div className="opening-moving-mobile-timeline-icon">
                    <div className="opening-moving-mobile-icon-badge badge-4">
                      <img src={openingMovingIcon4} className="opening-moving-mobile-icon" alt="화장 및 운구 아이콘" />
                    </div>
                    <div className="opening-moving-mobile-timeline-text">회장 및 운구</div>
                  </div>
                  <div className="opening-moving-mobile-timeline-number">4</div>
                </div>

                <div className="opening-moving-mobile-timeline-connector"></div>

                <div className="opening-moving-mobile-timeline-step">
                  <div className="opening-moving-mobile-timeline-icon">
                    <div className="opening-moving-mobile-icon-badge badge-5">
                      <img src={openingMovingIcon5} className="opening-moving-mobile-icon" alt="안치 아이콘" />
                    </div>
                    <div className="opening-moving-mobile-timeline-text">안치</div>
                  </div>
                  <div className="opening-moving-mobile-timeline-number">5</div>
                </div>
              </div>
            </div>

            {/* 개장 신고 Section */}
            <div className="opening-moving-mobile-report-section">
              <h3 className="opening-moving-mobile-section-title">개장 신고</h3>

              {/* Steps */}
              <div className="opening-moving-mobile-steps">
                <div className="opening-moving-mobile-step">
                  <div className="opening-moving-mobile-step-badge">1</div>
                  <div className="opening-moving-mobile-step-content">
                    <h4>신고</h4>
                    <p>개장신고서 작성</p>
                  </div>
                </div>
                <div className="opening-moving-mobile-step">
                  <div className="opening-moving-mobile-step-badge">2</div>
                  <div className="opening-moving-mobile-step-content">
                    <h4>접수</h4>
                    <p>개장신고자와 사망자의관계 확인 (제적등본)</p>
                  </div>
                </div>
                <div className="opening-moving-mobile-step">
                  <div className="opening-moving-mobile-step-badge">3</div>
                  <div className="opening-moving-mobile-step-content">
                    <h4>확인</h4>
                    <p>개장신고사항 확인</p>
                  </div>
                </div>
                <div className="opening-moving-mobile-step">
                  <div className="opening-moving-mobile-step-badge">4</div>
                  <div className="opening-moving-mobile-step-content">
                    <h4>검토</h4>
                    <p>개장신고사항 적합여부 검토</p>
                  </div>
                </div>
                <div className="opening-moving-mobile-step">
                  <div className="opening-moving-mobile-step-badge">5</div>
                  <div className="opening-moving-mobile-step-content">
                    <h4>결재</h4>
                    <p>결재</p>
                  </div>
                </div>
                <div className="opening-moving-mobile-step">
                  <div className="opening-moving-mobile-step-badge">6</div>
                  <div className="opening-moving-mobile-step-content">
                    <h4>작성</h4>
                    <p>관리대장 등 작성</p>
                  </div>
                </div>
                <div className="opening-moving-mobile-step">
                  <div className="opening-moving-mobile-step-badge">7</div>
                  <div className="opening-moving-mobile-step-content">
                    <h4>수리</h4>
                    <p>개장신고 증명서 발급 교부</p>
                  </div>
                </div>
              </div>

              {/* Additional Details */}
              <div className="opening-moving-mobile-details">
                <div className="opening-moving-mobile-detail-item">
                  <p><strong>신고유형:</strong> 사전신고제</p>
                </div>
                <div className="opening-moving-mobile-detail-item">
                  <p><strong>신고의무자:</strong> 개장을 하려는 자</p>
                </div>
                <div className="opening-moving-mobile-detail-item">
                  <p><strong>신고기관:</strong> 시체, 유골의 현존지, 개장지를 관할하는 주민자치센터</p>
                </div>
                <div className="opening-moving-mobile-detail-item">
                  <p><strong>구비서류:</strong> 기존분묘의 사진 (분묘에 비석이 포함된 근거리, 원거리 사진)</p>
                </div>
              </div>
            </div>

            {/* 개장신고 우선순위 Section */}
            <div className="opening-moving-mobile-priority-section">
              <h3 className="opening-moving-mobile-section-title">개장신고 우선순위</h3>
              <div className="opening-moving-mobile-priority-list">
                <div className="opening-moving-mobile-priority-item">
                  <div className="opening-moving-mobile-priority-badge">1순위</div>
                  <span>배우자</span>
                </div>
                <div className="opening-moving-mobile-priority-item">
                  <div className="opening-moving-mobile-priority-badge">2순위</div>
                  <span>자식</span>
                </div>
                <div className="opening-moving-mobile-priority-item">
                  <div className="opening-moving-mobile-priority-badge">3순위</div>
                  <span>부모</span>
                </div>
                <div className="opening-moving-mobile-priority-item">
                  <div className="opening-moving-mobile-priority-badge">4순위</div>
                  <span>부모를 제외한 직계존속</span>
                </div>
                <div className="opening-moving-mobile-priority-item">
                  <div className="opening-moving-mobile-priority-badge">5순위</div>
                  <span>형제/자매</span>
                </div>
              </div>
            </div>

            {/* 개장/이장 시 필요 서류 Section */}
            <div className="opening-moving-mobile-documents-section">
              <h3 className="opening-moving-mobile-section-title">개장/이장 시 필요 서류</h3>

              <div className="opening-moving-mobile-document-subsection">
                <h4 className="opening-moving-mobile-subsection-title">분묘개장신고필증 발급신청 시 필요 서류</h4>
                <ul className="opening-moving-mobile-document-list">
                  <li>분묘이장 신청자(직계가족)의 도장, 주민등록증 지참</li>
                  <li>분묘의 정확한 주소와 지번을 알고 계셔야 좋습니다.</li>
                  <li>망자의 가족관계 증명서 - 호적등본(제적등본) 1통</li>
                  <li>분묘 현장사진 1장 (비석이 있을 경우 쓰여진 글자가 보일 수 있게 찍습니다.)</li>
                </ul>
              </div>

              <div className="opening-moving-mobile-document-subsection">
                <h4 className="opening-moving-mobile-subsection-title">분묘개장신고필증 발급신청 시 필요 서류</h4>
                <ul className="opening-moving-mobile-document-list">
                  <li>대리신고시 - 직계 권리자의 위임장 1장, 위임용 인감 1부, 주민등록등본 1부, 가족관계증명서 1부</li>
                  <li>배정을 한자는 매장 후 30일 이내 관할 읍, 면사무소에 신고해야 합니다. (법 제8조 1항)</li>
                  <li>매장신고시 묘지설치신고를 함께하면 이중으로 관청에 출입하는 분평이 없습니다.</li>
                </ul>
              </div>

              <div className="opening-moving-mobile-document-subsection">
                <h4 className="opening-moving-mobile-subsection-title">화장장 예약시 필요 서류</h4>
                <ul className="opening-moving-mobile-document-list">
                  <li>화장장 이용서류</li>
                  <li>연고자 주민등록 등/초본</li>
                  <li>묘지 개장 신고필증 1부</li>
                </ul>
              </div>
            </div>


          </div>
        </div>
      </main>
    </div>
  );
};

export default OpeningMovingMobile; 